//singleton router

import UniversalRouter, { RouterOptions } from 'universal-router';
import generateUrls, { UrlParams } from 'universal-router/generateUrls';

export class TPCRouter {
    private static instance: TPCRouter;

    static BASE_URL = '/ajudante-ia-dever-casa/questao';
    static TUTOR_BASE_URL = '/tutor-ia/questao';
    static CHANGED_PAGE_EVENT = 'corrector-page-changed';
    static NEW_EXERCISE_PAGE = '/';
    static QUESTION_VIEW_PAGE = '/:uuid/';

    private isTutor = false;

    options: RouterOptions = {
        baseUrl: TPCRouter.BASE_URL,
    };

    private routes = [
        {
            name: TPCRouter.NEW_EXERCISE_PAGE,
            path: TPCRouter.NEW_EXERCISE_PAGE,
            action: () => `<tpc-corrector-question-create></tpc-corrector-question-create>`,
        },
        {
            name: TPCRouter.QUESTION_VIEW_PAGE,
            path: TPCRouter.QUESTION_VIEW_PAGE,
            action: (context) =>
                `<tpc-corrector-question-view questionUuid=${context.params.uuid}></tpc-corrector-question-view>`,
        },
    ];
    private router: UniversalRouter;
    url: (routeName: string, params?: UrlParams) => string;

    private element: HTMLElement | undefined;

    private constructor() {
        this.router = new UniversalRouter(this.routes, this.options);
        this.url = generateUrls(this.router);
    }

    public static getInstance(): TPCRouter {
        if (!TPCRouter.instance) {
            TPCRouter.instance = new TPCRouter();
        }
        return TPCRouter.instance;
    }

    resolvePath() {
        this.router
            .resolve(location.pathname)
            .then((html) => {
                if (this.element) {
                    this.element.innerHTML = '';
                    this.element.innerHTML = html as string;
                    this.sendPageChangedEvent();
                }
            })
            .catch(() => {
                this.gotToNotFound();
            });
    }

    setupRouter(element: HTMLElement, isTutor: boolean = false) {
        this.isTutor = isTutor;
        this.options.baseUrl = isTutor ? TPCRouter.TUTOR_BASE_URL : TPCRouter.BASE_URL;
        this.router = new UniversalRouter(this.routes, this.options);
        this.url = generateUrls(this.router);
        
        this.element = element;
        this.resolvePath();
        window.addEventListener('popstate', (e) => {
            this.resolvePath();
        });
        window.addEventListener('pushstate', (e) => {
            this.resolvePath();
        });
    }

    gotToNotFound() {
        window.location.href = '/404.php';
    }

    sendPageChangedEvent() {
        const event = new CustomEvent(TPCRouter.CHANGED_PAGE_EVENT);
        window.dispatchEvent(event);
    }

    goToPage(path: string) {
        this.router
            .resolve(path)
            .then((html) => {
                if (this.element) {
                    history.pushState({}, '', path);
                    this.element.innerHTML = '';
                    this.element.innerHTML = html as string;
                    this.sendPageChangedEvent();
                }
            })
            .catch(() => {
                window.location.href = path;
            });
    }
    isNewExercisePage() {
        const currentBaseUrl = this.isTutor ? TPCRouter.TUTOR_BASE_URL : TPCRouter.BASE_URL;
        return location.pathname === currentBaseUrl + TPCRouter.NEW_EXERCISE_PAGE;
    }

    goToNewExercisePage() {
        this.goToPage(this.url(TPCRouter.NEW_EXERCISE_PAGE));
    }

    gotToQuestionViewPage(questionUuid: string) {
        this.goToPage(this.url(TPCRouter.QUESTION_VIEW_PAGE, { uuid: questionUuid }));
    }
}
